import * as React from 'react';

import Icon from '../Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const MemberIcon: React.FC<Props> = props => {
  const size = props.size || 10;
  const color = props.color || '#ff8f13';
  return <Icon name={'project-member'} size={size} color={color} />;
};

export default React.memo(MemberIcon);
